var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChartAverage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7812 22.3438H10.4375C7.03455 22.3438 5.33307 22.3437 4.27592 21.2866C3.21875 20.2294 3.21875 18.5279 3.21875 15.125V3.78125",
    stroke: "#22C55E",
    strokeWidth: 1.6875,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3125 13.0625H6.32176M9.40439 13.0625H9.41365M12.4963 13.0625H12.5056M15.5882 13.0625H15.5975M18.6801 13.0625H18.6894M21.772 13.0625H21.7812",
    stroke: "#22C55E",
    strokeWidth: 1.6875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3125 7.90625C7.00703 6.74967 7.94922 5.84375 9.39885 5.84375C15.5276 5.84375 12.0828 18.2188 18.6688 18.2188C20.1288 18.2188 21.0653 17.3068 21.7812 16.1562",
    stroke: "#22C55E",
    strokeWidth: 1.6875,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartAverage);
export default __webpack_public_path__ + "static/media/chart-average.2badd755095ec3b8363a119b27ed89d1.svg";
export { ForwardRef as ReactComponent };